// extracted by mini-css-extract-plugin
export default {"container":"billcsstest_container__ic0XX","billBtn1":"billcsstest_billBtn1__wGqw7","billSubBtn1":"billcsstest_billSubBtn1__LCX6d"};